import schema from '../../../assets/formSchemas/formDataSchema.json'
import formFields from '../../../assets/formSchemas/formFields.json'

export default {
  MYINFO (state, payload) {
    state.myInfo = payload
  },
  PROFILEFIELDSET (state, payload) {
    var fieldset = formFields.profile
    var signupProperties = schema['nutricom.User'].properties
    var retArray = []

    fieldset.forEach(function (field) {
      if (signupProperties.hasOwnProperty(field.name)) {
        retArray.push(Object.assign({}, signupProperties[field.name], field))
      } else {
        retArray.push(field)
      }
    })
    state.profileUpdateSchema = retArray
  },
  PARENTUSERFIELDSET(state, payload) {
    const fieldset = formFields.parentUser
    const parentUserProperties = schema['nutricom.ParentUser'].properties
    let retArray = []
    const validators = payload ? payload.validators : null
    fieldset.forEach(function (field) {
      if (parentUserProperties.hasOwnProperty(field.name)) {
        if (validators && validators[field.name]) parentUserProperties[field.name].validator = validators[field.name]
        retArray.push(Object.assign({}, parentUserProperties[field.name], field))
      } else {
        retArray.push(field)
      }
    })
    state.parentUserSchema = retArray
  },
  USERID (state, payload) {
    state.userId = payload
  },
  CLIENT_ID (state, payload) {
    state.clientId = payload
  },
  CLIENT_INFO (state, payload) {
    state.clientInfo = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/store/profile/mutations.js